import { render, staticRenderFns } from "./DenunciationsPgHeader.vue?vue&type=template&id=78558cea&scoped=true&"
import script from "./DenunciationsPgHeader.vue?vue&type=script&lang=js&"
export * from "./DenunciationsPgHeader.vue?vue&type=script&lang=js&"
import style0 from "./DenunciationsPgHeader.vue?vue&type=style&index=0&id=78558cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78558cea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
